import { TStore } from "../../hooks/useService";
import { POST, respond } from "../Helpers";
import { TFetchDocumentReport, TFetchDocumentReportData, TFetchInventoryOnHandReport, TFetchInventoryOnHandReportData, TFetchPaymentsReport, TFetchPaymentsReportData, TFetchSalesReport, TFetchSalesReportData, TFetchSkoctInReport, TFetchSkoctInReportData, TFetchSkoctOutReport, TFetchSkoctOutReportData, TFetchSkycReport, TFetchSkycReportData, TFetchStockAgeingReport, TFetchStockAgeingReportData, TFetchStockOrderReport, TFetchStockOrdersReportData, TFetchStockReport, TFetchStockReportData, TFetchTransactionalReport, TFetchtransactionalReportData } from "./types";







export const getTransactionReport: TFetchTransactionalReport = (...params) => {
    return async (store: TStore) => {
      const { data, error } = await POST<TFetchtransactionalReportData>(
        "/getTransactionalReport",
        params,
        true
      );
      return respond(data, error);
    };
  };

  

export const getPaymentsReport: TFetchPaymentsReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchPaymentsReportData>(
      "/getPaymentsReport",
      params,
      true
    );
    return respond(data, error);
  };
};

export const getStockReport: TFetchStockReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchStockReportData>(
      "/getStockReport",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getStockOrdersReport: TFetchStockOrderReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchStockOrdersReportData>(
      "/getStockOrdersReport",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getInventoryOnHandReport: TFetchInventoryOnHandReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchInventoryOnHandReportData>(
      "/getInventoryOnHandReport",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getStockInReport: TFetchSkoctInReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchSkoctInReportData>(
      "/getStockInReport",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getStockOutReport: TFetchSkoctOutReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchSkoctOutReportData>(
      "/getStockOutReport",
      params,
      true
    );
    return respond(data, error);
  };
};

export const getSalesReport: TFetchSalesReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchSalesReportData>(
      "/getSalesReport",
      params,
      true
    );
    return respond(data, error);
  };
};


export const getDocumentsReport: TFetchDocumentReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchDocumentReportData>(
      "/getDocumentsReport",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getSkycReport: TFetchSkycReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchSkycReportData>(
      "/getSkycReport",
      params,
      true
    );
    return respond(data, error);
  };
};

export const getStockAgeingReport: TFetchStockAgeingReport = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchStockAgeingReportData>(
      "/getStockAgeingReport",
      params,
      true
    );
    return respond(data, error);
  };
};



